const productCreditPack = {
  creditPack: {
    label: "Pack de crédit",
  }
};

export default productCreditPack;
